// 将秒格式化为：
//  - 若 >= 24 小时：D天HH时MM分SS秒
//  - 若 < 24 小时：HH时MM分SS秒
export function formatCountdown(sec) {
  const total = Math.max(0, Number(sec) || 0);

  const daySeconds = 24 * 60 * 60;
  const days = Math.floor(total / daySeconds);
  const remainAfterDays = total % daySeconds;

  const hours = Math.floor(remainAfterDays / 3600);
  const minutes = Math.floor((remainAfterDays % 3600) / 60);
  const seconds = remainAfterDays % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  if (days > 0) {
    return `${days}天${hh}:${mm}:${ss}`;
  }

  return `${hh}:${mm}:${ss}`;
}

export function formatDateTime(value, type = "hm") {
  if (!value) return "";

  const pad2 = (n) => String(n).padStart(2, "0");

  // 优先处理常见字符串：'YYYY-MM-DD HH:mm:ss'
  if (typeof value === "string") {
    const v = value.trim();

    if (type === "md") {
      // '2026-06-12 ...' => '6-12'（去掉前导 0）
      const datePart = v.split(" ")[0] || "";
      const seg = datePart.split("-");
      if (seg.length >= 3) {
        const m = String(Number(seg[1]));
        const d = String(Number(seg[2]));
        if (m !== "NaN" && d !== "NaN") return `${m}-${d}`;
      }
    }

    if (type === "hm") {
      // '... 03:00:00' => '03:00'
      const parts = v.split(" ");
      const timePart = parts.length >= 2 ? parts[1] : parts[0];
      const hm = timePart.split(":");
      if (hm.length >= 2) return `${pad2(hm[0])}:${pad2(hm[1])}`;
    }
  }

  // 兜底：Date / 时间戳
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  if (type === "md") {
    return `${d.getMonth() + 1}-${d.getDate()}`;
  }

  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function startSingleCountdownTimer(vm, prop = "nowCountdown", timerKey = "countsingledownTimer") {
  if (!vm) return null;
  clearSingleCountdownTimer(vm, timerKey);
  vm[timerKey] = window.setInterval(() => {
    const getByPath = (obj, path) => {
      if (!obj || !path) return undefined;
      if (typeof path !== "string" || !path.includes(".")) return obj[path];
      return path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
    };

    const setByPath = (obj, path, value) => {
      if (!obj || !path) return;
      if (typeof path !== "string" || !path.includes(".")) {
        if (typeof obj.$set === "function") {
          obj.$set(obj, path, value);
        } else {
          obj[path] = value;
        }
        return;
      }

      const keys = path.split(".");
      const lastKey = keys.pop();
      const target = keys.reduce((acc, key) => {
        if (acc == null) return acc;
        return acc[key];
      }, obj);
      if (target == null) return;

      if (typeof obj.$set === "function") {
        obj.$set(target, lastKey, value);
      } else {
        target[lastKey] = value;
      }
    };

    const curr = Number(getByPath(vm, prop)) || 0;
    if (curr > 0) {
      setByPath(vm, prop, curr - 1);
    } else {
      clearSingleCountdownTimer(vm, timerKey);
    }
  }, 1000);
  return vm[timerKey];
}

export function clearSingleCountdownTimer(vm, timerKey = "countsingledownTimer") {
  if (!vm) return;
  if (vm[timerKey]) {
    window.clearInterval(vm[timerKey]);
    vm[timerKey] = null;
  }
}

export function startListCountdownTimer(
  vm,
  listProps = [],
  field = "countDown",
  timerKey = "countdownTimer",
) {
  if (!vm) return null;
  clearListCountdownTimer(vm, timerKey);

  const dec = (arr) => {
    if (!Array.isArray(arr)) return;
    arr.forEach((it) => {
      if (!it || typeof it[field] === "undefined") return;
      const v = Number(it[field]) || 0;
      it[field] = v > 0 ? v - 1 : 0;
    });
  };

  vm[timerKey] = window.setInterval(() => {
    (listProps || []).forEach((p) => {
      const arr = typeof p === "string" ? vm[p] : p;
      dec(arr);
    });
  }, 1000);

  return vm[timerKey];
}

export function clearListCountdownTimer(vm, timerKey = "countdownTimer") {
  if (!vm) return;
  if (vm[timerKey]) {
    window.clearInterval(vm[timerKey]);
    vm[timerKey] = null;
  }
}





export function formatNumber(num) {
  return Number(num || 0).toLocaleString("en-US");
}

